export { default as ConfirmModal } from './index.vue';

export { use_modal as use_confirm_modal } from '@/components/modal';
